import { parseMoneyToCents, centsToInput } from './money'

// The server stores the contract price as `priceCents` and computes the balance, but the
// forms edit the price as dollars in a text field called `price`. These two helpers
// convert between the stored shape and the form shape.

// Stored property -> form state
export function propertyToForm (property) {
  if (!property) return property
  return { ...property, price: centsToInput(property.priceCents) }
}

// Form state -> body for the API. Returns { errors } when the price is not an amount.
// Fields the server computes (balance, paid, ...) are never sent back.
export function formToPropertyPayload (form) {
  const priceCents = form.price === undefined ? form.priceCents : parseMoneyToCents(form.price)
  if (priceCents === null || priceCents < 0) {
    return { errors: { priceCents: 'Price must be a valid dollar amount' } }
  }
  const { price, balanceCents, chargesCents, paymentsCents, paid, ...rest } = form
  return { payload: { ...rest, priceCents } }
}
